module.exports = __webpack_public_path__ + "static/media/maintenance-icon.ac23887b.svg";